import { BLLViewCariler } from './../../../providers/bll/bll-viewCariler';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {   NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-carisec',
  templateUrl: 'carisec.html',
})
export class CarisecPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  cariListesi = [];
  CariID:string;
 
  

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
     public navParams: NavParams,
     public viewCtrl:ViewController,
     public ortak:Ortak,
     public modalCtrl:ModalController) {

  }

  ionViewDidLoad() {
    this.OnlinecariAra();
    // this.girismesaji();
  }
  girismesaji()
  {
    this.ortak.showBasicAlert("Uyarı","Lütfen Mal Aldığınız Firmayı veya Cari'yi Seçiniz..");
  }
  OnlinecariAra() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.ortak.StAyarGetir.CariListeSayisi.toString());
    formData.append("grupkodu", "-1");
    this.bllOrtak.islem(formData, "CariListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
          
    })
  }
  OfflineCariAra()
  {
    var cariler=new BLLViewCariler();
    cariler.getAll().then(a=>{
      var sonuc=<any>a;
      this.cariListesi=sonuc;
      if(this.cariListesi.length==0)
      {
        this.OnlinecariAra();
      }
    })
  }
  urunler(e) {

    if(this.aranan.length>3)
    {
      this.OnlinecariAra();

    }
    if(this.aranan.length==0)
    {
      this.OnlinecariAra();
    }
  
  }
  CariSec(aktarilacakCariKart) {
    this.viewCtrl.dismiss(aktarilacakCariKart);
 }
 kapat()
 {
   this.viewCtrl.dismiss();
 }
}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/carisec/carisec.ts